import axios from 'axios';

import { getBaseURL, authErrorInterceptor, authTokenHeaderInterceptor } from "../helpers";
import { listParamsInterceptor } from '@/helpers/url';


/**
 * Default Axios instances config.
 * @type {import('axios').AxiosRequestConfig}
 */
const BASE_CONFIG = {
    baseURL: `${getBaseURL()}api/`,
};

const instance = axios.create(BASE_CONFIG);

instance.interceptors.request.use(listParamsInterceptor);
instance.interceptors.response.use(null, authErrorInterceptor);

export const authAxios = axios.create(BASE_CONFIG);

authAxios.interceptors.request.use(listParamsInterceptor);
authAxios.interceptors.request.use(authTokenHeaderInterceptor);
authAxios.interceptors.response.use(null, authErrorInterceptor);

export default instance;


// WEBPACK FOOTER //
// ./src/axios/axios.js